import { render, staticRenderFns } from "./CloutInfo.vue?vue&type=template&id=84189046"
import script from "./CloutInfo.vue?vue&type=script&lang=js"
export * from "./CloutInfo.vue?vue&type=script&lang=js"
import style0 from "./CloutInfo.vue?vue&type=style&index=0&id=84189046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports